module.exports = __webpack_public_path__ + "img/rophil.427c2ec7.jpg";